import React from 'react';

// Common components
import MobileLinks from '../common/MobileLinks/MobileLinks';

// Container components
import DragAreaContainer from './DragAreaContainer/DragAreaContainer';
import ExamplesContainer from './ExamplesContainer/ExamplesContainer';
import AbTestingContainer from './AbTestingContainer/AbTestingContainer';

// Component Styles
import './upload.scss';

/**
 * This function renders the Upload component page and its components.
 */
export default function Upload() {
  return (
    <div className='wtfUpload'>
      <AbTestingContainer />
      <DragAreaContainer />

      <ExamplesContainer />
      <hr className='wtfUpload_separator' />
      <div className='wtfUpload_explanation'>
        <p>
          How it works: WhatTheFont uses deep learning to search our collection of over 133,000 font styles
          and find the best match for the fonts in your photo. It even works with connected scripts and when
          there’s more than one font in an image. Just upload an image, click the font you want to identify,
          then check out the results.
        </p>
        <p>
          For best results, upload a good quality image, and make sure the text is horizontal. We’ll detect
          the text in the image automatically, then you can click the font you want. You can draw a manual
          crop box if you want, but be sure that you only draw it around one line of text.
        </p>
        <p>
          Happy font hunting!
        </p>
      </div>
      <hr className='wtfUpload_separator' />
      <MobileLinks />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Upload/index.js